import { Box, Text, Badge } from '@mantine/core';
import type { FieldMemo } from '../../types';
import { formatDateMMDD } from '../../utils/dateUtils';

interface MemoItemProps {
  memo: FieldMemo;
  fieldName?: string;
}

export function MemoItem({ memo, fieldName }: MemoItemProps) {
  return (
    <Box
      style={{
        padding: '0.5rem 0',
      }}
    >
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
        }}
      >
        <Text size="xs" c="dimmed">
          {formatDateMMDD(memo.createdAt)}
        </Text>
        <Text size="xs" fw={500}>
          {memo.userName}
        </Text>
      </Box>
      {fieldName && (
        <Box style={{ marginTop: '0.125rem' }}>
          <Badge size="xs" color="dark" variant="filled">
            {fieldName}
          </Badge>
        </Box>
      )}
      <Box
        className="memo-content-scroll"
        style={{
          marginTop: '0.25rem',
          maxHeight: '6em',
          overflowY: 'auto',
        }}
      >
        <Text size="sm">{memo.content}</Text>
      </Box>
    </Box>
  );
}
